import { SET_STAND_ALONE_MODE, SET_SHOW_CAVEON_ID_MODAL, SET_PRIMARY_COLOR, SET_SECONDARY_COLOR, SET_PREVIEW_URL } from '../actions/types'

const appStateReducer = function (state = {
  standAloneMode: false,
  isSafari: navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1,
  previewUrl: '',
  showCaveonIdModal: false
}, action) {
  switch (action.type) {
    case SET_PREVIEW_URL:
      return {
        ...state,
        previewUrl: action.previewUrl
      }
    case SET_STAND_ALONE_MODE:
      return {
        ...state,
        standAloneMode: action.isInStandAloneMode
      }
    case SET_PRIMARY_COLOR:
      return {
        ...state,
        primaryColor: action.color
      }
    case SET_SECONDARY_COLOR:
      return {
        ...state,
        secondaryColor: action.color
      }
    case SET_SHOW_CAVEON_ID_MODAL:
      return {
        ...state,
        showCaveonIdModal: action.showCaveonIdModal
      }
    default:
      return state
  }
}
export default appStateReducer



// WEBPACK FOOTER //
// /app/js/reducers/appStateReducer.js